import { MAX_PAGE_LIMIT as o } from "./constants.js";
const a = (m) => {
  const t = ~~m;
  return t === m && t > 0 ? Math.min(t, o) : Math.max(t, 0);
};
export {
  a as getClampedPageLimit
};
